/**
 * Derived view state for a vendor card's badge: connected (green) and/or
 * needs-action (orange). Shared across the org + company integration overviews so
 * the badge semantics live in one place.
 */
export interface VendorBadgeState {
    connected: boolean;
    needsAction: boolean;
    /**
     * Badge text override (i18n key), e.g. an Accounto API key that expires soon or has expired
     * (REV-21119 D7). Wins over `connected` / `needsAction` on the card.
     */
    badgeKey?: string;
    badgeVariant?: 'connected' | 'action' | 'danger';
}
